module.exports = __webpack_public_path__ + "img/s4-1-ja.f3e62003.jpg";